import React, {useContext} from 'react';
import isMobile from './isMobile';

const isMobileResult = isMobile();

export const MobileWebContext = React.createContext<boolean>(isMobileResult);
export const useIsMobile = () => useContext(MobileWebContext);
